export default function Half({ children }) {
  return <div className="flex flex-col flex-1 min-w-0">{children}</div>;
}
